<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="body">
            <div class="center">
                <div class="c_left">
                    <div>{{ info.groupName || '' }}</div>
                    <div>总数：{{ total }}</div>
                </div>
                <div class="c_right" @click="$router.push({ path: '/questionCreate', query: { id: id } })">添加题目</div>
            </div>
            <div class="bottom">
                <el-table :header-cell-style="{ background: '#F7F8FA' }" :data="list" style="width: 100%;"
                    :height="'100%'">
                    <el-table-column label="序号" width="100">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="questionType" label="题目类型" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.type == 1">单选题</el-tag>
                            <el-tag v-if="scope.row.type == 2">多选题</el-tag>
                            <el-tag v-if="scope.row.type == 3">判断题</el-tag>
                            <el-tag v-if="scope.row.type == 4">主观题</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="subjectName" label="学科" width="100"></el-table-column>
                    <el-table-column prop="questionContent" label="题目"></el-table-column>
                    <el-table-column prop="techClassQuestionOpt" label="选项">
                        <template slot-scope="scope">
                            <el-tag style="margin:0 10px 10px 0;" :type="item.optionAnswer == 1 ? 'success' : ''"
                                v-for="item in scope.row.techClassQuestionOpt" :key="item.id" v-if="scope.row.type != 4">
                                {{ item.optionNo + '：' + item.optionContent }}
                            </el-tag>
                            <div class="line2_" :title="scope.row.questionAnalyse" style="height: 50px;cursor: pointer;" v-if="scope.row.type == 4">{{ scope.row.questionAnalyse }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sort" label="排序" width="160">
                        <template slot-scope="scope">
                            <el-input-number size="small" v-model="scope.row.sort" controls-position="right"
                                @change="val => handleChange(val, scope.row.id)" :min="1"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                    <el-table-column label="操作" width="210">
                        <template slot-scope="scope">
                            <el-button type="primary" size="small" plain @click="$router.push({ path: '/questionCreate', query: { id: id,item:JSON.stringify(scope.row) } })">修改</el-button>
                            <el-button type="warning" size="small" plain v-if="scope.row.status == 0"
                                @click="btn_status(scope.row)">停用</el-button>
                            <el-button size="small" plain v-if="scope.row.status == 1"
                                @click="btn_status(scope.row)">启用</el-button>
                            <el-button type="danger" size="small" plain @click="btn_del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {
    detailQuestionGroup,
    questionGroupQuestionList,
    editQuestionSort,
    editQuestionStatus,
    deleteQuestion
} from '@/apis/index'
export default {
    data() {
        return {
            id: this.$route.query.id,
            info: {},
            pageNum: 1,
            pageSize: 10,
            total: 0,
            list: []
        }
    },
    mounted() {
        if (this.id) {
            this.getInfo()
        }
    },
    methods: {
        btn_del(row) {
            this.$confirm('是否确定删除该题目？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteQuestion(this.id, row.id).then(res => {
                    this.$message.success('删除成功')
                    this.pageNum = 1
                    this.getList()
                })
            })
        },
        btn_status(row) {
            editQuestionStatus(this.id, row.id, row.status == 1 ? 0 : 1).then(res => {
                this.$message.success('修改成功')
                this.pageNum = 1
                this.getList()
            })
        },
        handleChange(val, id) {
            console.log(val);
            editQuestionSort(this.id, id, val).then(res => {
                this.$message.success('修改成功')
                this.pageNum = 1
                this.getList()
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val
            this.getList()
        },
        getList() {
            questionGroupQuestionList(this.id, this.pageNum, this.pageSize).then(res => {
                console.log(res, 'questionGroupQuestionList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.total = res.data.total
                this.list = res.data.list
            })
        },
        getInfo() {
            detailQuestionGroup(this.id).then(res => {
                console.log(res, 'detailQuestionGroup');
                this.info = res.data
                this.getList()
            })
        },
        load() {
            console.log('sssss');

        }
    }
}
</script>

<style lang="scss" scoped>
.line2_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

::v-deep {
    .el-tag {
        min-height: 32px !important;
        white-space: pre-wrap;
    }
}

.line1_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.line2_ {
    word-break: break-all;
    display: -webkit-box !important;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.back {
    width: 1400px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    // margin-bottom: 10px;
    margin-top: 10px;
    cursor: pointer;
    box-sizing: border-box;

    img {
        width: 14px;
        height: 14px;

    }
}

.body {
    width: 1400px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    box-sizing: border-box;

    .center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 40px 0;

        .c_left {
            display: flex;
            align-items: center;

            div:nth-child(1) {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-right: 20px;
            }

            div:nth-child(2) {
                font-weight: 500;
                font-size: 14px;
                color: #999999;
            }
        }

        .c_right {
            width: 104px;
            height: 36px;
            background: #399AFF;
            border-radius: 8px 8px 8px 8px;
            font-weight: 800;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
        }
    }

    .bottom {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
    }
}
</style>